<template>
  <b-card :img-src="image" img-alt="Image" img-top tag="article" @click="goCourse(id)" class="card-article card-course "
    style="border-color: #3D84CE;">
    <!-- Title -->
    <p style="font-size: 13px;margin-bottom: 5px;min-height: 19.5px;">{{ register }}</p>
    <div class="card-title mb-4">
      <span class=" text-ellipsis-1-lines" style="max-width: 100%;">
        {{ header }}
      </span>
    </div>

    <!-- Description -->
    <span class=" text-ellipsis-3-lines" v-html="content"></span>
    <!-- Footer slot -->
    <template #footer>
      <div class="d-flex align-items-center">
        <b-avatar :src="creator_img" size="40px" class="mx-3 my-3"></b-avatar>
        <div class="d-flex flex-column" style="min-width: 0;">
          <span class="text-truncate" style="max-width: 100%;">
            {{ creator }}
          </span>
          <small class="text-muted" style="font-size: 10px;">
            {{ creator_position }}
          </small>
        </div>
      </div>
    </template>

  </b-card>
</template>

<script>
import moment from "moment";

export default {
  props: ["header", "content", "image", "id", "paid_type", "price", "status", "approve_right", "access_rights", "enroll", "author_name", "creator", "creator_img", "register", "creator_position"],
  computed: {
    replacedText() {
      return this.content
        .replace(/<p>/g, '')
        .replace(/<\/p>/g, '');
    },

  },
  methods: {
    async goCourse(id) {
      const path = `/courses`;
      await this.$router.push({ path: path, query: { id: id } });
    },

    checkCoursepPaidType(id) {
      this.$emit('open-modal', id);
    }
    , isDisable() {
      let isDisable = true;

      if (this.enroll) {
        let enroll = this.enroll;
        let currentDate = moment();
        let registerStart = enroll ? moment(enroll.register_start) : false;
        let registerEnd = enroll ? new moment(enroll.register_end) : false;

        let courseStart = enroll ? new moment(enroll.course_start) : false;
        let courseEnd = enroll ? new moment(enroll.course_end) : false;

        if ((registerStart && registerEnd) && (courseStart && courseEnd)) {
          if (this.access_rights === 'public' || (this.access_rights === 'private' && this.approve_right !== null)) {
            if (enroll.user_enroll.length > 0 && currentDate <= courseEnd) {
              isDisable = false;
            } else if (enroll.user_enroll.length == 0 && currentDate < registerEnd) {
              isDisable = false;
            }
          }
        }
      }
      return isDisable;
    }

    , cardText() {
      let text = 'ซื้อคอร์สนี้';
      let currentDate = moment();
      let enroll = this.enroll;
      let registerStart = enroll ? moment(enroll.register_start) : false;
      let registerEnd = enroll ? new moment(enroll.register_end) : false;

      let courseStart = enroll ? new moment(enroll.course_start) : false;
      let courseEnd = enroll ? new moment(enroll.course_end) : false;
      if ((this.access_rights === 'private' && this.approve_right !== null) || (this.access_rights === 'public')) {

        if (!(currentDate.isBetween(registerStart, registerEnd)) && enroll.user_enroll.length === 0) {
          text = 'ปิดรับสมัคร'
        } else if (!(currentDate.isBetween(courseStart, courseEnd)) && enroll.user_enroll.length > 0) {
          text = 'คอร์สเรียนสิ้นสุด'
        }
      } else {
        if (!(currentDate.isBetween(registerStart, registerEnd)) && enroll.user_enroll.length === 0) {
          text = 'ปิดรับสมัคร'
        } else if (!(currentDate.isBetween(courseStart, courseEnd)) && enroll.user_enroll.length > 0) {
          text = 'คอร์สเรียนสิ้นสุด'
        }
      }
      return text;
    }
  },
};
</script>

<style scoped>


.price-course {
  font-weight: 700;
  font-size: 20px;
}

.card-img,
.card-img-top {
  height: 155px !important;
  object-fit: cover;
}

.short-desc {
  color: #798497;
}

.card-footer {
  padding-top: 0px;
}

.text-ellipsis-1-lines {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%
}

.text-ellipsis-3-lines {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #798497;
  font-size: 10px;
}

.card-course {
  transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid #135193;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  /* เงาปกติ */
}

/* Hover effect: scale + border-color */
.card-course:hover {
  transform: scale(1.05);
  border: 2px solid #135193;
  box-shadow: 0 2px 6px #135193;
  /* เปลี่ยนสีเงาเป็นสีเข้ม */
}

/* Remove background from .card-body */
.card-course .card-body {
  background-color: transparent !important;
}

.card-footer {
  padding-left: 0px;
}
</style>
